var _defs, _style, _use, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 63",
    width: 500,
    height: 492,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "restaurant-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 64,
    height: 63,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA/AQMAAABq01yJAAAAAXNSR0IB2cksfwAAAANQTFRF2trg/LlC0QAAAA9JREFUeJxjYBgFo4BkAAACNwABXLkNfwAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 0,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m44 31.7v15.7c0 0.3-0.2 0.5-0.5 0.5h-15.9c-0.3 0-0.5-0.2-0.5-0.5v-15.7c0-0.3 0.2-0.5 0.5-0.5h15.9c0.3 0 0.5 0.2 0.5 0.5zm-1 0.5h-14.9v14.7h14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m32.1 43q0.2 0.1 0.4 0.1 0.2 0 0.3-0.1l6.2-6.1c0.2-0.2 0.2-0.5 0-0.7-0.2-0.2-0.5-0.2-0.7 0l-6.2 6c-0.2 0.2-0.2 0.6 0 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m32.4 38.3q0.2 0 0.3-0.2l3.4-3.3c0.2-0.2 0.2-0.5 0-0.7-0.2-0.2-0.5-0.2-0.7 0l-3.4 3.3c-0.2 0.2-0.2 0.5 0 0.7q0.2 0.2 0.4 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m36.2 45.7q0.1 0.2 0.3 0.2 0.2 0 0.4-0.2l4.1-4.1c0.2-0.2 0.2-0.5 0-0.7-0.2-0.2-0.5-0.2-0.7 0l-4.1 4.1c-0.2 0.2-0.2 0.5 0 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m23.6 31.7v16.7c0 0.3-0.2 0.5-0.5 0.5h-12.9c-0.3 0-0.5-0.2-0.5-0.5v-16.7c0-0.3 0.2-0.5 0.5-0.5h12.9c0.3 0 0.5 0.2 0.5 0.5zm-1 0.5h-11.9v15.7h11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m21.5 42.2c0.3 0 0.5-0.2 0.5-0.5v-2.1c0-0.3-0.2-0.5-0.5-0.5-0.2 0-0.5 0.2-0.5 0.5v2.1c0 0.3 0.3 0.5 0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m61 50.5c0 0.3-0.2 0.5-0.5 0.5h-53.5c-0.3 0-0.5-0.2-0.5-0.5v-20.9c-0.7-0.1-1.4-0.5-1.9-1-0.7-0.7-1.1-1.6-1.1-2.6v-3.8c-0.2 0-0.4-0.1-0.4-0.2-0.1-0.2-0.1-0.4 0-0.6l0.9-1.1q0 0 0 0 0.2-0.3 0.4-0.6l4.9-6.5q0.2-0.2 0.4-0.2h34.1q0.2 0 0.4 0.2l5.3 7q0 0.1 0 0.1 0.1 0 0.1 0.1l0.8 1c0.1 0.2 0.1 0.4 0.1 0.6-0.1 0.1-0.3 0.2-0.5 0.2v3.8c0 1.8-1.3 3.3-3 3.6v20.4h1.2l1.8-10.2q0-0.1 0-0.1 0 0 0-0.1 0 0 0.1 0 0-0.1 0.1-0.1 0 0 0-0.1 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0.1 0h6.3q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.2 0 0 0 0 0 0 0.1 0 0.1 0.1 0 0.1 0.1 0 0 0 0 0 0 0 0 0.1 0.1 0.1 0.1 0 0 0 0.1 0 0 0 0l1.8 10.2h1.4c0.3 0 0.5 0.2 0.5 0.5zm-11.3-3.1h5.3l1.2-7h-5.3zm7.1-4.7l-0.8 4.7h1.6zm-4.1 7.1h1.9l0.2-1.5h-2.4zm2.9 0h2.5l-0.3-1.6h-1.9zm-6.4 0h2.5l-0.3-1.6h-1.9zm-0.2-27.7h-5.5v3.7c0 0.8 0.3 1.4 0.8 2 0.5 0.5 1.2 0.8 1.9 0.8 1.6 0 2.8-1.3 2.8-2.8zm-6.5 0h-5.5v3.8c0 0.7 0.3 1.4 0.8 1.9 0.5 0.5 1.2 0.8 1.9 0.8 1.6 0 2.8-1.2 2.8-2.7zm-6.5 0h-5.5v3.7c0 0.7 0.3 1.4 0.8 1.9 0.5 0.6 1.2 0.9 1.9 0.9 1.6 0 2.8-1.3 2.8-2.8zm-6.5 0h-5.5v3.8c0 0.7 0.3 1.4 0.8 1.9 0.5 0.5 1.2 0.8 1.9 0.8 1.5 0 2.8-1.2 2.8-2.7zm-6.5 0h-5.5v3.7c0 0.7 0.3 1.4 0.8 1.9 0.5 0.6 1.2 0.8 1.9 0.8 1.5 0 2.8-1.2 2.8-2.7zm-6.5 0h-5.5v3.8c0 0.7 0.2 1.4 0.8 1.9 0.5 0.5 1.2 0.8 1.9 0.8 1.5 0 2.8-1.2 2.8-2.7zm-11.3-2q0 0 0 0-0.1 0.1-0.2 0.2l-0.2 0.3c0 0.1-0.1 0.1-0.1 0.2l-0.2 0.3h44.5l-0.3-0.4q0 0 0 0 0 0-0.1-0.1l-5.1-6.8h-33.5zm0 7.6c0.5 0.5 1.3 0.8 2 0.8 1.5 0 2.7-1.2 2.7-2.7v-3.7h-5.5v3.7c0 0.7 0.3 1.4 0.8 1.9zm2.2 22.1h38.6v-20.3c-0.9 0-1.8-0.4-2.4-1.1q-0.4-0.3-0.6-0.8c-0.7 1.2-1.9 1.9-3.3 1.9-1 0-1.9-0.4-2.6-1.1q-0.4-0.3-0.6-0.8c-0.7 1.2-1.9 1.9-3.3 1.9-1 0-2-0.4-2.6-1.1q-0.4-0.3-0.6-0.8c-0.7 1.2-1.9 1.9-3.3 1.9-1 0-1.9-0.4-2.7-1.1q-0.3-0.3-0.6-0.8c-0.6 1.2-1.8 1.9-3.2 1.9-1 0-2-0.4-2.7-1.1q-0.3-0.3-0.6-0.8c-0.6 1.2-1.8 1.9-3.2 1.9-1 0-2-0.4-2.7-1.1q-0.3-0.3-0.6-0.8c-0.6 1.1-1.7 1.8-3 1.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.76c00b9dfcc7c6ec568cc1e33908b532.svg";
export { ForwardRef as ReactComponent };